<template>
  <div class="content">
    <div class="content__title content__title--party">
      <h1 class="title title--big title--theme">Паспорт РО РСМ</h1>
      <button @click="onExport" type="button" class="link link--right">
        <img src="@/assets/img/file/import-icon.svg" alt="Скачать">
        <span>Скачать Word</span>
      </button>
    </div>
    <div class="content__title">
      <h2 class="title title--theme">Региональная организация: {{ regionOrgName }}</h2>
    </div>
    <div class="report report--indent">
      <div class="report__list">
        <router-link :to="{ name: 'passport-org' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnaccepted('PassportQuestionnaire') }">
            <img src="@/assets/img/number-leaf.svg" alt="Blue leaf">
            <span>1</span>
          </div>
          <div class="report__title">Общие сведения об организации</div>
        </router-link>
        <router-link :to="{ name: 'passport-head' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnaccepted('GoverningBody') }">
            <img src="@/assets/img/number-leaf.svg" alt="Blue leaf">
            <span>2</span>
          </div>
          <div class="report__title">Сведения о руководящих органах организации</div>
        </router-link>
        <router-link :to="{ name: 'passport-control' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnaccepted('AuditBody') }">
            <img src="@/assets/img/number-leaf.svg" alt="Blue leaf">
            <span>3</span>
          </div>
          <div class="report__title">Сведения о контрольно-ревизионном органе организации</div>
        </router-link>
        <router-link :to="{ name: 'passport-workers' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnaccepted('SupportForm') }">
            <img src="@/assets/img/number-leaf.svg" alt="Blue leaf">
            <span>4</span>
          </div>
          <div class="report__title">Работники аппарата региональной организации РСМ (включая работников на общественных началах)</div>
        </router-link>
        <router-link :to="{ name: 'passport-immovables' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnaccepted('RealEstate') }">
            <img src="@/assets/img/number-leaf.svg" alt="Blue leaf">
            <span>5</span>
          </div>
          <div class="report__title">Сведения о недвижимом имуществе, находящемся в собственности региональной организации РСМ, аренде</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/http/axios/axios';

export default {
  name: 'Passport',
  data() {
    return {
      modelUnacceptedCache: {}, // реактивный объект для Vue 2
    };
  },
  computed: {
    regionOrgName() {
      return this.$store.state.organizationName;
    },
    regionOrg() {
      return this.$store.state.organization;
    },
  },
  mounted() {
    if (this.regionOrg) {
      this.loadStatuses();
    }
  },
  methods: {
    hasUnaccepted(modelName) {
      return this.modelUnacceptedCache[modelName] === true;
    },

    async loadStatuses() {
      if (!this.regionOrg) return;

      try {
        const response = await axios.get('/user/users/unified-history/', {
          params: { region_org_id: this.regionOrg, page_size: 1000 }
        });

        const records = response.data.results || [];
        const latestByObject = new Map();

        // Берём последнюю запись по object_id
        for (const entry of records) {
          const key = `${entry.model_name}-${entry.object_id}`;
          if (!latestByObject.has(key)) {
            latestByObject.set(key, entry);
          }
        }

        const unacceptedModels = new Set();

        for (const entry of latestByObject.values()) {
          // Пропускаем удалённые записи
          if (entry.action_type === '-') continue;

          let status = null;
          if (entry.changes?.status?.new !== undefined) {
            status = String(entry.changes.status.new).trim();
          } else if (entry.current_status !== undefined) {
            status = String(entry.current_status).trim();
          }

          if (status && !['accepted', 'Принята'].includes(status)) {
            unacceptedModels.add(entry.model_name);
          }
        }

        // Обновляем реактивный кэш
        this.$set(this, 'modelUnacceptedCache', {});
        for (const model of unacceptedModels) {
          this.$set(this.modelUnacceptedCache, model, true);
        }
      } catch (e) {
        console.error('[Passport] Ошибка загрузки статусов:', e);
      }
    },

    onExport() {
      this.$store.dispatch('passport/GET_EXPORT')
        .then(response => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Паспорт_РО_${this.regionOrg}.docx`);
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(error => {
          error.response?.data?.text?.().then(res => {
            const errorJson = JSON.parse(res);
            for (const key in errorJson) {
              this.$notify({
                type: 'error',
                title: 'Внимание!',
                text: Array.isArray(errorJson[key]) ? errorJson[key][0] : errorJson[key]
              });
            }
          }).catch(() => {
            this.$notify({ type: 'error', title: 'Ошибка', text: 'Не удалось скачать файл' });
          });
        });
    }
  },
  watch: {
    regionOrg(newVal) {
      if (newVal) {
        this.loadStatuses();
      }
    }
  }
};
</script>

<style scoped>
.report__number--changed {
filter: hue-rotate(176deg) saturate(1.5);
}
</style>